import React, { useState, useEffect } from "react";

// Components
import { UserDetail } from "shared/components/user";
import Loading from "shared/components/loading/Loading";

// actions
import { useAuthUser, useDispatch } from 'shared/state';
import { makeAPIRequest } from "shared/state/fetch";
import { useTokenStatus } from "shared/state/auth/actions";

const Profile = ()=> {
    const { user } = useAuthUser();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [currentProfile, setCurrentProfile] = useState('');
    const { handleTokenStatus } = useTokenStatus();
    const profileID = user ? user.id : false;

    useEffect(() => {
        if(profileID) {
            makeAPIRequest(`profile/${profileID}`)
                .then(response => {
                    setIsLoading(false);
                    setCurrentProfile(response.result.data);
                    response.status && handleTokenStatus(response);
                }
            )
        }
    }, [profileID]);

    const handleOnSave = (updatedUser) => {
        const headers = {
            'Access-Control-Allow-Origin': '*',
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data'
        }

        makeAPIRequest('profile', 'POST', updatedUser, headers)
            .then(response => {
                setCurrentProfile(response.result);
                !response.status && dispatch({ type: 'LOGGED_IN_USER', payload: response.result });
                response.status && handleTokenStatus(response);
            }
        )
    }

    return (
        <section>
            <h1 className="pageHeading"> Profile </h1>
            { currentProfile &&
                <UserDetail
                    role={ user && user.role }
                    user={ currentProfile }
                    onSave={ handleOnSave } />
            }
            <Loading isLoading={ isLoading && currentProfile }/>
        </section>
    );
}

export default Profile;
